
import pdfIcon from "./../../../assets/images/pdf.png"; // Adjust the path as necessary
import { WebApiURL } from '../../../Constants/Constants';
import React, { useEffect, useMemo, useState } from 'react';
import { useFileContext } from '../../../Contexts/FileContext';
import CryptoJS from "crypto-js";
import { encryptFileIdValue } from "../../../utils/encryption";

function OpportunitiesCodeOFConduct() {
    const [activeIndex, setActiveIndex] = useState(0);
    const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
    const secretKey = "MySAMSASecretKey2025"; // same as backend

    const encryptFileId = (fileId) => {
        const ciphertext = CryptoJS.AES.encrypt(fileId.toString(), secretKey).toString();
        return encodeURIComponent(ciphertext);
    };
    const { setComponentName, setSection, documents, loading } = useFileContext();
    useEffect(() => {
        setComponentName("Code Of Conduct");
    }, [setComponentName]);
    // Extract unique sections dynamically
    const sections = useMemo(() => {
        const sectionSet = new Set();
        documents?.forEach((doc) => {
            const section = typeof doc?.section === 'string' ? doc.section.trim() : '';
            if (section) sectionSet.add(section);
        });
        return Array.from(sectionSet);
    }, [documents]);
    const renderDocumentsBySection = (sectionName) => {
        const docs = documents?.filter(doc =>
            String(doc?.section || '').trim().toLowerCase() === String(sectionName || '').trim().toLowerCase()
        );
        const grouped = docs?.reduce((acc, doc) => {
            const folder = doc?.folderName || doc?.section || "Uncategorized";
            if (!acc[folder]) acc[folder] = [];
            acc[folder].push(doc);
            return acc;
        }, {});
        return (
            <ul className="strip-ul">
                {Object.entries(grouped).map(([folderName, folderDocs], idx) => (
                    <li key={idx}>
                        <div className="row g-4">
                            <div className="col-auto">
                                <img src={pdfIcon} alt="PDF icon" />
                            </div>
                            <div className="col">
                                <div className="row g-4">
                                    <div className="col-md">
                                        <div className="font-18 font-600">File Name</div>
                                        <div className="font-16 font-400">
                                            <p className="text-orange-ef3e33 text-uppercase">
                                                {folderName}
                                            </p>
                                            <ul className="list">
                                                {folderDocs.map((doc, i) => (
                                                    <li key={i}>
                                                        {/* <a
                                                            href={`${WebApiURL}File/view/${encodeURIComponent(doc.fileId)}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            {doc.fileName}
                                                        </a> */}
                                                        <a
                                                            href={`${WebApiURL}File/view/${encryptFileIdValue(doc.fileId)}`}
                                                            //href={`${WebApiURL}File/view/${encodeBase64(doc.fileId.toString())}`}
                                                            // target="_blank"
                                                            rel="noopener noreferrer"
                                                        >{doc.fileName}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-auto">
                                        <div className="font-18 font-600">Modified</div>
                                        <div className="font-16 font-400">
                                            {folderDocs[0]?.modifiedDate
                                                ? new Date(folderDocs[0].modifiedDate).toLocaleString()
                                                : "—"}
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        );
    };
    return (
        <>
            <div className="service-title text-green-38B652 font-700 mb-3">
                General Conditions of Contract
                <span className="text-orange-ef3e33 font-400"></span>
            </div>
            {/* <div className="service-box mb-5 mb-sm-4">
                Communication to Suppliers :<br />{" "}
                <a
                    className="text-decoration-none text-green-38B652 font-600"
                    href="/Documents/Opportunitie/SupplyChainManagement/SCM_COMMUNICATION_TO_SUPPLIERS_INVOICES.pdf" target="_blank" rel="noopener noreferrer">

                    Click here to view the document
                </a>
            </div>             */}

            <div className="row g-3 g-sm-4 g-md-4">
                <div className="col-12">
                    <div className="accordion blackTab" id="blackTab">
                        {sections?.map((sectionName, idx) => (
                            <div className="accordion-item" key={sectionName}>
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ${activeIndex !== idx ? "collapsed" : ""}`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#section-${idx}`}
                                        aria-expanded={idx === 0 ? "true" : "false"}
                                        aria-controls={`section-${idx}`}
                                        onClick={() => setActiveIndex(idx)}
                                    >
                                        {sectionName}
                                    </button>
                                </h2>
                                <div
                                    id={`section-${idx}`}
                                    className={`accordion-collapse collapse ${activeIndex === idx ? "show" : ""}`}
                                    data-bs-parent="#blackTab"
                                >
                                    <div className="accordion-body px-0">
                                        {loading ? (
                                            <div>Loading documents...</div>
                                        ) : (
                                            renderDocumentsBySection(sectionName)
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>


            </div>
        </>
    );
}

export default OpportunitiesCodeOFConduct;


